module.exports = __webpack_public_path__ + "img/tscb.3ab33fbf.png";